
import formComponent from './form_component'
import defaultParser from '../parsers/list_parser'
import httpClient from '@/api/http-client'

const http = httpClient.http
const MODE_API = 'api'
const MODE_CUSTOM = 'custom'

export default {

  mixins: [ formComponent ],

  /**
   * Внешние данные компонента.
   *
   */
  props: {

    // Режим
    mode: {
      type: String,
      required: true
    }
  },

  /**
   *
   *
   */
  data() {

    return {

      // Список данных
      list: [],

      // Значение по умолчанию
      default: null
    }
  },

  /**
   *
   *
   */
  watch: {

    /**
     * Изменение режима работы компонента.
     *
     */
    mode: {

      handler: function () {

      },

      deep: true,
      immediate: true
    }
  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     * Инициализация компонента.
     *
     *  - подключение парсера
     *  - устновка названия элемента
     *  - получение списка данных по API (для api-компонентов)
     *  - инициализация списка данных и значения по умолчанию
     *
     */
    init() {

      // Инициализация парсера.
      this.initParser( defaultParser )

      this.name = this.parser.getName( this.data )

      //
      if ( this.isApi() ) {
        this.getServerData( this.parser.getUrl( this.data ) )
      }
      else {

        this.list = this.parser.getList( this.data )
        this.default = this.parser.getDefault( this.data )

        this.setDefault( this.list[ this.default ] )
      }
    },

    /**
     * Получение списка данных и значения по умолчанию по API.
     *
     * url - адрес метода API
     *
     */
    getServerData( url ) {

      http.get( url ).then( response => {

        if ( response.status == 200 && response.data ) {

          this.setApiData( response.data )
        }
        else {

          this.dataLoadingError = true;
          this.$dmsErrorNoty( 'Произошла ошибка при загрузке данных' );
        }
      } ).catch( error => {

        console.warn( error );
        this.dataLoadingError = true;
        this.$dmsErrorNoty( 'Произошла ошибка при загрузке данных' );

      } ).finally( () => {

        // Clear loading indicator
        this.loading = false;
      } )
    },

    /**
     * Установка значения по умолчанияю.
     *
     */
    setDefault( defaultItem ) {
      this.$set( this.data, 'value', defaultItem )
    },

    /**
     * Инициализация списка данных и значения по умолчанию,
     * полученных по API.
     *
     * data - данные, полученные по API
     *
     */
    setApiData( data ) {

      this.list = this.parser.getApiList( data )
      this.default = this.parser.getApiDefault( data )

      this.setDefault( this.list[ this.default ] )
    },

    /**
     * Проверка api-режима компонента.
     *
     * Если компонент работает в режиме получения
     * списка данных по API, возвращается true.
     * Иначе возвращается false.
     *
     */
    isApi() {
      return this.mode === MODE_API
    },

    /**
     * Проверка custom-режима компонента.
     *
     * Если компонент работает в режиме получения
     * списка данных сразу при инициализации, возвращается true.
     * Иначе возвращается false.
     *
     */
    isCustom() {
      return this.mode === MODE_CUSTOM
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/components/mixins/form_list_component.js